import apiClient from '@skygroup/shared/API/apiClient';
import endpoints from '@skygroup/shared/API/endpoints';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMembershipUser } from '../store/config';
import { message } from 'antd';
import { RootState } from '../store/store';

const useMembershipAuthHelpers = () => {
  const { translations: t } = useSelector((state: RootState) => state.config);

  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const logoutMembership = useCallback(({ showMessage = true, reload = true }: { showMessage?: boolean, reload?: boolean } = {}) => {
    dispatch(setMembershipUser(null));
    localStorage.removeItem('membershipUser');
    // localStorage.removeItem('lastMessageShownTimestamp');
    if (showMessage) {
      message.success(t?.auth?.logoutSuccess);
    }
    if (reload) {
      window.location.reload();
    }
  }, [dispatch, t?.auth?.logoutSuccess]);

  const checkMembershipExpiration = useCallback(
    (authData: any) => {
      if (!authData.expiration_date) {
        return false;
      }
      const isActive = new Date(authData.expiration_date) > new Date();
      if (!isActive) {
        logoutMembership();
      }
      return isActive;
    },
    [logoutMembership]
  );

  const checkIfAuthenticated = useCallback(() => {
    const authDataString = localStorage.getItem('membershipUser');
    debugger
    if (!authDataString) {
      return false;
    }
    try {
      const authData = JSON.parse(authDataString);
      dispatch(setMembershipUser(authData));
      const isActive = checkMembershipExpiration(authData);
      return isActive;
    } catch (error) {
      return false;
    }
  }, [checkMembershipExpiration, dispatch]);

  useEffect(() => {
    setIsAuthenticated(checkIfAuthenticated());
  }, [checkIfAuthenticated]);

  const membershipLogin = useCallback(
    async (id: string, phone: string, auth_type: string) => {
      const response = await apiClient.post(endpoints.AUTH.lOGIN_OTP, {
        id,
        phone,
        auth_type,
      });

      // const formData = new FormData();
      // formData.append('id', id);
      // formData.append('phone', phone);
      // formData.append('auth_type', auth_type);
      // const response = await apiClient.post(endpoints.AUTH.lOGIN_OTP, formData);

      if (response.data.status != 'success') {
        throw new Error(response.data?.data?.message);
      }

      // Return full response data to check is_registered status
      return response.data;
    },
    []
  );

  const verifyOTPFn = useCallback(
    async (sessionId: string, code: string, auth_type: string) => {
      const response = await apiClient.post(endpoints.AUTH.VERIFY_OTP, {
        session_id: sessionId,
        code,
        auth_type,
      });
      if (response.data.status != 'success') {
        throw new Error(response.data?.data?.message);
      }

      // const simulatedResponse = {
      //   ...response.data.data.membershipUser,
      //   expiration_date: new Date(
      //     Date.now() + 3 * 24 * 60 * 60 * 1000
      //   ).toISOString(),
      // };
      // return simulatedResponse;

      return response.data.data.membershipUser;
    },
    []
  );

  return { isAuthenticated, membershipLogin, verifyOTPFn, logoutMembership };
};

export default useMembershipAuthHelpers;
